/**
 * Branch type definition
 */
export interface Branch {
  id: string;
  name: string;
}

/** Normalize branch_switching from login/DB (1, "1", true, "True", etc.) to 0 | 1. */
export function parseBranchSwitchingFlag(value: unknown): number {
  if (value === true || value === 1) return 1;
  if (value === false || value === 0 || value === null || value === undefined) {
    return 0;
  }
  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();
    if (normalized === "true" || normalized === "yes" || normalized === "on") {
      return 1;
    }
    if (
      normalized === "false" ||
      normalized === "no" ||
      normalized === "off" ||
      normalized === ""
    ) {
      return 0;
    }
    const parsed = Number(normalized);
    if (!Number.isNaN(parsed)) {
      return parsed !== 0 ? 1 : 0;
    }
  }
  if (typeof value === "number") {
    return value !== 0 ? 1 : 0;
  }
  return 0;
}

export function hasBranchSwitchingPermission(
  user?: { branch_switching?: number } | null
): boolean {
  return parseBranchSwitchingFlag(user?.branch_switching) === 1;
}

/**
 * Per-screen CRUD permission entry from the login payload
 */
export interface UserLevelPermission {
  Id?: string;
  ScreenId: string;
  UserId?: string;
  Add: boolean;
  Edit: boolean;
  Delete: boolean;
  Unlock: boolean;
  View: boolean;
  Void: boolean;
}

/**
 * Per-module permission entry from the login payload
 */
export interface ModuleLevelPermission {
  user_level_permission: number;
  group_level_permission: number | null;
  server_level_permission: number;
  effective_permission: number;
  effective_source: string;
}

/**
 * Extended User Info with branch switching support
 */
export interface UserInfo {
  name: string;
  id: string;
  email: string;
  role: string;
  phone: string;
  branch: string; // Branch name (for display)
  branch_id: string | null; // Branch ID (for API)
  branch_name: string | null; // Branch name (alternative)
  branch_switching: number; // 0 or 1 - permission flag
  employee_id?: string; // Optional employee ID from user data
  userlevelpermissions?: UserLevelPermission[]; // Per-screen permission flags
  modulelevelpermissions?: Record<string, ModuleLevelPermission>; // Per-module permission flags
}
